import GameOptions from "../options/GameOptions";

/**
 */
export default class GameOptionsSave {
    constructor() {
    }

    /**
     * @param {GameOptions} gameOptions 
     * @returns {Object}
     */
    static generateSave(gameOptions) {
        const saveState = {};

        saveState.crewBrainDebugEnabled = gameOptions.crewBrainDebugEnabled;
        saveState.maxFps = gameOptions.maxFps;
        saveState.displayFps = gameOptions.displayFps;

        saveState.dynamicLightingEnabled = gameOptions.dynamicLightingEnabled;
        saveState.effectsRenderingEnabled = gameOptions.effectsRenderingEnabled;
        saveState.depthColumnRendered = gameOptions.depthColumnRendered;
        saveState.wireframeModeEnabled = gameOptions.wireframeModeEnabled;


        return saveState;
    }

    /**
     * @param {GameOptions} gameOptions 
     * @param {Object} saveState 
     */
    static loadSave(gameOptions, saveState) {
        if (!saveState) {
            return;
        }

        gameOptions.crewBrainDebugEnabled = false;
        if (saveState.crewBrainDebugEnabled) {
            gameOptions.crewBrainDebugEnabled = true;
        }

        if (saveState.maxFps) {
            gameOptions.maxFps = saveState.maxFps;
        }

        gameOptions.displayFps = false;
        if (saveState.displayFps) {
            gameOptions.displayFps = true;
        }

        // true by default:
        gameOptions.dynamicLightingEnabled = true;
        if (saveState.dynamicLightingEnabled !== undefined) {
            gameOptions.dynamicLightingEnabled = saveState.dynamicLightingEnabled;
        }

        // true by default:
        gameOptions.effectsRenderingEnabled = true;
        if (saveState.effectsRenderingEnabled !== undefined) {
            gameOptions.effectsRenderingEnabled = saveState.effectsRenderingEnabled;
        }

        // true by default:
        gameOptions.depthColumnRendered = true;
        if (saveState.depthColumnRendered !== undefined) {
            gameOptions.depthColumnRendered = saveState.depthColumnRendered;
        }

        gameOptions.wireframeModeEnabled = false;
        if (saveState.wireframeModeEnabled) {
            gameOptions.wireframeModeEnabled = true;
        }
    }
}